import React from "react";
const xmlns = "http://www.w3.org/2000/svg";

export function FaIcon(props) {
  const { icon: iconProps, children, ...rest } = props;

  const { prefix, iconName, icon } = iconProps;
  /* eslint-disable no-unused-vars */
  const [width, height, ligatures, unicode, svgPathData] = icon;

  const dataFa = `${prefix}-${iconName}`;

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      xmlns={xmlns}
      role={"img"}
      aria-hidden="true"
      data-fa={dataFa}
      {...rest}
    >
      {children}
      {Array.isArray(svgPathData) ? (
        <g>
          <path d={svgPathData[0]} />
          <path d={svgPathData[1]} />
        </g>
      ) : (
        <path d={svgPathData} />
      )}
    </svg>
  );
}
